import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AssignmentScheduleService } from '../../services/assignment-schedule.service';
import { AssignmentScheduleUpdateAdditionPostModel } from '../../models/assignment-schedule-update-addition-post.model';
import { SharedToasterService } from '../../../../shared/services/shared-toaster.service';

@Component({
    templateUrl: './assignment-schedule-answer-addition-modal.component.html',
    styleUrl: './assignment-schedule-answer-addition-modal.component.scss'
})
export class AssignmentScheduleAnswerAdditionModalComponent implements OnInit {
    @Output() onSuccess = new EventEmitter<boolean>();

    @Input({ required: true }) assignmentScheduleId!: string;
    @Input({ required: true }) comment!: string | null;
    @Input({ required: true }) wishCount!: number | null;
    @Input({ required: true }) isWishCountActive!: boolean;

    private bsModalRef = inject(BsModalRef);
    private formBuilder = inject(FormBuilder);
    private assignmentScheduleService = inject(AssignmentScheduleService);
    private sharedToasterService = inject(SharedToasterService);

    protected isLoading: boolean = false;
    protected answerAdditionForm!: FormGroup;

    constructor(
    ) { }

    ngOnInit(): void {
        this.initForm();
    }

    private initForm(): void {
        this.answerAdditionForm = this.formBuilder.group({
            comment: [this.comment],
            wishCount: [this.wishCount]
        })
    }


    protected save(): void {
        this.updateAddition();
    }

    private close(): void {
        this.bsModalRef.hide();
    }

    private updateAddition(): void {

        var model: AssignmentScheduleUpdateAdditionPostModel = {
            comment: this.answerAdditionForm.value.comment,
            countWish: this.answerAdditionForm.value.wishCount,
        }

        console.log(model);

        this.assignmentScheduleService.changeAssignmentScheduleAdditionById(this.assignmentScheduleId, model).subscribe({
            next: () => {
                this.onSuccess.emit(true);
                this.close();
            },
            error: () => {
                this.sharedToasterService.showGeneralSavingError();
            }
        });
    }

}
